import { AlertTriangle } from "lucide-react";

import {
  DTEF_DIVERGENCE_WARNING_MESSAGE,
  DTEF_DIVERGENCE_WARNING_TITLE,
} from "../constants";

interface DtefDivergenceWarningProps {
  divergentCategories: string[];
}

const WARNING_CONTAINER_CLASSES =
  "w-full p-4 bg-amber-50 border border-amber-200 rounded-lg";
const WARNING_LAYOUT_CLASSES = "flex items-start gap-3";
const WARNING_ICON_CLASSES =
  "h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0";
const WARNING_BODY_CLASSES = "flex-1";
const WARNING_TITLE_CLASSES =
  "text-sm font-semibold text-amber-800 mb-2";
const WARNING_MESSAGE_CLASSES = "text-sm text-amber-900 mb-2";
const WARNING_LIST_CLASSES = "list-disc pl-5 space-y-1";
const WARNING_ITEM_CLASSES = "text-sm text-amber-700";

export function DtefDivergenceWarning({
  divergentCategories,
}: DtefDivergenceWarningProps) {
  if (divergentCategories.length === 0) return null;

  return (
    <div className={WARNING_CONTAINER_CLASSES}>
      <div className={WARNING_LAYOUT_CLASSES}>
        <AlertTriangle className={WARNING_ICON_CLASSES} />
        <div className={WARNING_BODY_CLASSES}>
          <h3 className={WARNING_TITLE_CLASSES}>
            {DTEF_DIVERGENCE_WARNING_TITLE}
          </h3>
          <p className={WARNING_MESSAGE_CLASSES}>
            {DTEF_DIVERGENCE_WARNING_MESSAGE}
          </p>
          <ul className={WARNING_LIST_CLASSES}>
            {divergentCategories.map(category => (
              <li key={category} className={WARNING_ITEM_CLASSES}>
                {category}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
